import { colord, extend } from 'colord';
import namesPlugin from 'colord/plugins/names';
import type { DesignTokenType } from './types';

extend([namesPlugin]);

export function normalizeDesignTokenValue<T extends DesignTokenType>(
	type: T,
	value: unknown
): T extends 'number' ? number : string;
// eslint-disable-next-line no-redeclare -- TypeScript overload preserves type/value inference.
export function normalizeDesignTokenValue(type: DesignTokenType, value: unknown): string | number {
	if (type === 'number') {
		if (typeof value !== 'number' || !Number.isFinite(value))
			throw new Error('Number tokens require a finite number.');
		return value;
	}
	if (typeof value !== 'string' || !value.trim() || /[;{}<>]/.test(value))
		throw new Error('Enter a literal token value.');
	const text = value.trim();
	if (type === 'color') {
		const color = colord(text);
		if (!color.isValid()) throw new Error('Enter a valid color.');
		const { r, g, b, a } = color.toRgb();
		return `rgba(${r}, ${g}, ${b}, ${a})`;
	}
	if (type === 'dimension') {
		if (!/^[-+]?(?:\d+(?:\.\d+)?|\.\d+)px$/i.test(text))
			throw new Error('Size requires a pixel value (for example 10px).');
		return `${Number(text.slice(0, -2))}px`;
	}
	if (type === 'fontFamily') {
		if (/var\(|[\n\r]/i.test(text)) throw new Error('Select a font family.');
		return text;
	}
	throw new Error('Unsupported token type.');
}
